import { Link } from '@tanstack/react-router';
import React from 'react';
import styles from './index.module.css';

export type LearnerPageBreadCrumbProps = {
  title: string;
};

export const LearnerPageBreadCrumb = ({
  title,
}: LearnerPageBreadCrumbProps) => {
  return (
    <ul className={styles.breadCrumb}>
      <li>
        <Link to="/" className={styles.attendanceLink}>
          科目一覧
        </Link>
      </li>
      <li>
        <span>&gt;</span>
        {title}
      </li>
    </ul>
  );
};
